<icon-text [icon]="'fad fa-wifi-1 text-danger'" [size]="40" class="wrap">
  <b class="uppercase text-danger">Lỗi kết nối</b>
  <br />
  <span class="lowercase">Xin vui lòng kiểm tra kết nối internet</span>
</icon-text>
<br/>
<button class="bg-success text-white" (click)="retry.emit()"><i class="far fa-sync"></i><span>Thử tải lại dữ liệu</span></button>

